module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE STORY OF HENRY VIII AND HIS")]), _vm._v(" six wives is a well-known example of the caprice and violence that dominated that King’s reign. Now Derek Wilson examines a set of relationships that more vividly illustrates just how dangerous life was in the court of the Tudor lion. He tells the interlocking stories of six men—all curiously enough named Thomas—whose ambitions and principles brought them face to face with violent death, as recorded in a simple mnemonic:")]), _vm._v(" "), _c('div', {
    staticClass: "flap"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Died, beheaded, beheaded,")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Self-slaughtered, burned, survived.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLSEY")]), _vm._v(" was an accused traitor on his way to the block when a kinder death intervened. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" and T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROMWELL")]), _vm._v(", whose convictions and policies could scarcely have been more different, both perished beneath the headman’s axe. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWARD")]), _vm._v(", Duke of Norfolk, would have met the same end had the king’s own death not brought him an eleventh-hour reprieve. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIOTHESLEY")]), _vm._v(", Earl of Southampton, and T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANMER,")]), _vm._v(" Archbishop of Canterbury, though outliving the monarch, perished as a result of that war of ambitions and ideologies which rumbled on after 1547. Wriothesley succumbed to poison of either body or mind in the aftermath of a failed coup. Cranmer went to the stake as a heretic at the insistence of Mary Tudor, who was very much the daughter of the father she hated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("In the Lion’s Court")]), _vm._v(" is an illuminating examination of the careers of the six Thomases, whose lives are described in parallel—their family and social origins, their pathways to the Royal Council chamber, their occupancy of the Siege Perilous, and the tragedies that, one by one, overwhelmed them. By showing how events shaped and were shaped by relationships and personal destinies, Derek Wilson offers a fresh approach to the political narrative of a tumultuous reign."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREK")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILSON")]), _vm._v(", a leading biographer and novelist, came to prominence thirty years ago, after graduating from Cambridge University, with "), _c('em', [_vm._v("A Tudor Tapestry: Men, Women, and Society in Reformation England.")]), _vm._v(" This was followed by several critically acclaimed bestsellers: "), _c('em', [_vm._v("Rothschild: The Wealth and Power of a Dynasty; Sweet Robin: A Biography of Robert Dudley, Earl of Leicester; Hans Holbein: Portrait of an Unknown Man;")]), _vm._v(" and, most recently, "), _c('em', [_vm._v("The King and The Gentleman: Charles Stuart and Oliver Cromwell 1599-1649.")]), _vm._v(" He has also written and presented numerous radio and television programs. Now, after three decades of study and reflection, he returns to those themes he first explored in "), _c('em', [_vm._v("A Tudor Tapestry.")]), _vm._v(" More details can be found on his Web site: "), _c('a', {
    attrs: {
      "href": "http://www.derekwilson.com",
      "target": "_blank"
    }
  }, [_vm._v("www.derekwilson.com.")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("ST. MARTIN’S PRESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("175 F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENUE,")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORK,")]), _vm._v(" N.Y. 10010")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3063c9db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/flap.vue
// module id = 57
// module chunks = 0